import { render } from "./resRecordBase.vue?vue&type=template&id=317d8684&scoped=true"
import script from "./resRecordBase.vue?vue&type=script&lang=js"
export * from "./resRecordBase.vue?vue&type=script&lang=js"

import "./resRecordBase.vue?vue&type=style&index=0&id=317d8684&lang=less&scoped=true"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317d8684"]])

export default __exports__